<template>
  <el-select
    v-model="typeMailModel"
    @change="typeMailChanged"
    autocomplete="new-password"
    :placeholder="$t('TEMPLATES_MAILS.TYPE')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getTypeMails"
    :loading="loading"
  >
    <el-option
      v-if="allowNone"
      :value="null"
      :label="$t('COMMON.NONE')"
    ></el-option>
    <el-option
      v-for="(typeMail, key) in typeMails"
      :key="key"
      :value="typeMail.id"
      :label="`${typeMail.label}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "type-mail-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    allowCreate: {
      type: Boolean,
      default: false,
      description: "Allow tag creation",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    typeMail: {
      type: String,
      default: null,
      description: "typeMail id",
    },
  },

  data() {
    return {
      typeMailModel: this.typeMail,
      typeMails: {},
    };
  },

  setup() {},

  created() {
    this.getTypeMails(null, this.typeMail);
  },

  methods: {
    async getTypeMails(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "label",
          filter: {
            ...(query ? { search: query } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        await this.$store.dispatch("typeMails/list", params);
        const typeMailsArr = await this.$store.getters["typeMails/list"];
        this.typeMails = {};
        typeMailsArr.forEach((typeMail) => {
          this.typeMails[typeMail.id] = typeMail;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    typeMailChanged(typeMail) {
      const typeMailModel = this.typeMails[typeMail] ?? {
        id: null,
        type: "type-mails",
      };

      this.$emit("typeMailChanged", typeMail, typeMailModel);
    },
  },

  watch: {
    typeMail(typeMail) {
      if (typeMail) {
        this.typeMailModel = typeMail;
        if (typeMail !== this.typeMailModel) {
          this.getTypeMails(null, typeMail);
        }
      } else {
        this.typeMailModel = null;
      }
    },
  },
};
</script>
